// extracted by mini-css-extract-plugin
export default {"wrapper":"LoginPage_wrapper__tLc0A","bg":"LoginPage_bg__3breO"};